/**
 * @file Facebook
 */
'use strict';

/**
 * @classname Facebook
 * @classdesc Facebook
 */
export default class Facebook {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('Facebook.constructor');
		this._$e = $e;
		this._script = false;
		$e.on('click', () => this.onClick());
		$(window).on('resize', () => {
			this._draw = false;
			$('#fb-root').remove();
			$('#fb-script').remove();
			this.setFacebook();
		})
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof Facebook
	 * @return {undefined}
	 */
	onClick() {
		console.log('Facebook.onClick');
		this.setFacebook();
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof Facebook
	 * @return {undefined}
	 */
	setFacebook() {
		console.log('Facebook.setFacebook');
		let script1 = `
<div id="fb-root"></div>
<script id="fb-script" async defer crossorigin="anonymous" src="https://connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v11.0&appId=591131622013254&autoLogAppEvents=1" nonce="l11fKOh6"></script>
		`;
		let width = $('.block--facebook').width();
		if(width > 500) width = 500;
		let script2 = `
<div class="fb-page" data-href="https://www.facebook.com/kosodateswitch/" data-tabs="timeline" data-width="${width}" data-height="274" data-small-header="true" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="false">
	<blockquote cite="https://www.facebook.com/kosodateswitch/" class="fb-xfbml-parse-ignore">
		<a href="https://www.facebook.com/kosodateswitch/">とうきょう子育てスイッチ</a>
	</blockquote>
</div>`;
		if(!this._script){
			$('body').prepend(script1);
			this._script = true;
		}
		$('.block--facebook').html(script2);
		window.FB.XFBML.parse();
	};
}
